import { useLocation, useNavigate } from "react-router-dom";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import { Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import {
  EditMetaDataItem,
  SaveMetaDataItem,
} from "../../api/metadataFieldsApi/metadataFieldsApi";
import { MetaDataItemModel } from "../../types/MetaDataItemModel";
import InfoIcon from "@mui/icons-material/Info";
import { useLoader } from "../../context/LoaderContext";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";

const MetadataFieldsAction: React.FC = () => {
  const { showSnackbar } = useSnackbar();
  const { setLoading } = useLoader();
  const location = useLocation();
  const action = location.state?.action || {};
  const rowData = location.state?.rowData || {};
  const [fieldName, setFieldName] = useState(rowData.itemname);
  const [isActive, setIsActive] = useState(rowData.active ?? true);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [errors, setErrors] = useState<{
    fieldNameError?: string;
  }>({});

  const [, setData] = useState<any>([]);// NOSONAR
  const navigate = useNavigate();

  const handleCreate = async () => {
    setLoading(true);
    try {
      const newErrors: {
        fieldNameError?: string;
      } = {};
      if (!fieldName) {
        newErrors.fieldNameError = "Field Name is required";
      }
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        const param: any = {
          ItemId: rowData.itemid === undefined ? 0 : rowData.itemid,
          ItemName: fieldName,
          CreatedBy: Number(LocalStorageUtil.getItem("userId")),
          CreatedDate: null,
          LastModifiedDate: null,
          UpdatedBy: Number(LocalStorageUtil.getItem("userId")),
          Active: isActive,
        };
        await SaveMetaDataItem(param);
        navigate("/metadataitemdisplay");
        if (action === "Edit") {
          showSnackbar("Metadata Field updated successfully");
        } else {
          showSnackbar("Metadata Field created successfully.");
        }
      }
    } catch (error) {
      console.error("Error in handleCreate", error);
    } finally {
      setLoading(false);
    }
  };

  // Get the metadata field data on edit mode
  useEffect(() => {
    if (action === "Edit") {
      getFieldData();
    }
  }, []);

  // Get the metadata field data
  const getFieldData = async () => {
    setLoading(true);
    try {
      const param: MetaDataItemModel = {
        ItemId: rowData.itemid,
        ItemName: undefined,
        CreatedDate: undefined,
        LastModifiedDate: undefined,
        CreatedBy: rowData.createdBy,
        IsSuperAdmin: 1,
        SearchText: undefined,
        UpdatedBy: rowData.updatedBy,
        FirstName: undefined,
        LastName: undefined,
        Active: undefined,
        FieldCounts: undefined,
        NoOfRecords: 25,
        CurrentPage: 1,
        SortColumn: undefined,
        SortOrder: undefined,
        TotalRecords: undefined,
        IsexporttpExcel: false,
        ContextName: undefined,
      };
      let response = await EditMetaDataItem(param);
      if (response) {
        setData(response);
        setFieldName(response[0].itemname);
      } else {
        setFieldName("");
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  //Close the dialog box after confirmation
  const handleConfirmDialogClose = (confirm: boolean) => {
    try {
      setConfirmDialogOpen(false);
      if (confirm) {
        navigate("/metadataitemdisplay");
      } else {
        setConfirmDialogOpen(false);
      }
    } catch (error) {
      console.error("Error in handleConfirmDialogClose", error);
    }
  };

  //Cancel the dialog box
  const handelCancel = () => {
    setConfirmDialogOpen(true);
  };

  // Change the status of metadata field
  const handelStatusChange = async () => {
    setIsActive(!isActive);
  };

  // Return the metadata field form
  return (
    <div>
      {action === "Edit" ? (
        <NavigationBar
          menuTitle="Configuration"
          title="Metadata Management"
          screenTitle="Metadata Fields"
          text="Metadata Field - Update Metadata Field"
        />
      ) : (
        <NavigationBar
          menuTitle="Configuration"
          title="Metadata Management"
          screenTitle="Metadata Fields"
          text="Metadata Field - Create Metadata Field"
        />
      )}
      <div
        className="rp-main-inner col-sm-12"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        {/* Active/In-Active */}
        <div
          className="col-sm-5"
          style={{
            width: "97%",
            textAlign: "right",
            margin: "10px",
          }}
        >
          {action === "Edit" && (
            <Tooltip
              title={
                isActive === true
                  ? "Click to make a role as inactive"
                  : "Click to make a role as active"
              }
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isActive}
                    onChange={handelStatusChange}
                    color="primary"
                    size="small"
                  />
                }
                label={isActive ? "Active" : "In-Active"}
                style={{
                 
                  margin: "1px 3px" ,
                    textTransform: "none",
                    fontSize: "11px",
                    color: isActive ? "#154360" : "#7B241C",
                    backgroundColor: isActive ? "#D6EAF8" : "#FADBD8",
                    padding: "3px 6px",
                    borderRadius: "3px",
                    alignItems: "center",
                    height: "2.5em",
                }}
              />
            </Tooltip>
          )}
        </div>
      </div>
      <h4
        style={{
          color: "var(--aggrid-text-color)",
          margin: "20px",
          fontSize: "12px",
        }}
      >
        {" "}
        Basic Information
      </h4>
      <div className="form-inp col-sm-12">
        <Row style={{ margin: "10px" }}>
          <Col>
            <Form>
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group controlId="formGroupName">
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      Field Name<span className="required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Field Name"
                      name="fieldname"
                      isInvalid={!!errors.fieldNameError}
                      value={fieldName}
                      onChange={(e) => setFieldName(e.target.value)}
                      required
                      className="input-box"
                      style={{ fontSize: "11px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fieldNameError}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
      <div className="form-group" style={{ margin: "20px", fontSize: "11px" }}>
        <small
          className="recom-msg guide"
          title="Info"
          style={{ color: "var(--aggrid-text-color)" }}
        >
          <InfoIcon />
          <br />
          1. Please enter Alphabets and Numbers only
          <br />
          (Special Characters are not allowed).
          <br />
          2. Maximum of 100 characters can be entered.
          <br />
          3. Metadata Field cannot be left Blank.
          <br />
          4. Metadata Field Name should be Unique.
          <br />
          5. Example : Document File Name
        </small>
      </div>
      <div className="form-inp col-sm-12">
        <Row>
          <Col
            md={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginLeft: "-50px",
            }}
          >
            <Button
              variant="contained"
              className="update-button"
              onClick={handleCreate}
            >
              {action === "Edit" ? "Update" : "Create"}
            </Button>
            <Button
              variant="contained"
              className="cancel-button"
              onClick={handelCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </div>
      <Dialog
        open={confirmDialogOpen}
        onClose={() => handleConfirmDialogClose(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          style={{
            backgroundColor: "var(--primary-color)",
            color: "var(--aggrid-text-color)",
            fontSize: "14px",
          }}
        >
          Metadat Field -{action === "Edit" ? "Update" : "Create New"}{" "}
        </DialogTitle>
        <DialogContent style={{ fontSize: "14px", marginTop: "20px" }}>
          Are you sure you want to Cancel?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleConfirmDialogClose(true)}
            color="primary"
            style={{
              fontSize: "14px",
              color: "var(--aggrid-text-color)",
              backgroundColor: "var(--primary-color)",
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => handleConfirmDialogClose(false)}
            color="primary"
            style={{
              fontSize: "14px",
              color: "var(--aggrid-text-color)",
              backgroundColor: "var(--primary-color)",
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MetadataFieldsAction;
